import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalServiceProvidersService } from '../../../services/external-service-providers.service';
import { ExternalServiceProvider } from '../../../models/ExternalServiceProvider';
import { getServiceTypeCssClass } from '../../../models/ExternalServiceProviderEnums';

@Component({
  selector: 'app-external-service-providers-view',
  templateUrl: './external-service-providers-view.component.html',
  styleUrls: ['./external-service-providers-view.component.css']
})
export class ExternalServiceProvidersViewComponent implements OnInit {
  provider: ExternalServiceProvider | null = null;
  isLoading = false;
  providerId: number | null = null;

  get serviceTypeClass(): string {
    return getServiceTypeCssClass(this.provider?.serviceType);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private externalServiceProvidersService: ExternalServiceProvidersService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.providerId = +params['id'];
        this.loadProvider();
      }
    });
  }

  loadProvider(): void {
    if (!this.providerId) return;

    this.isLoading = true;
    this.externalServiceProvidersService.getById(this.providerId).subscribe({
      next: (provider) => {
        this.provider = provider;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
        this.provider = null;
      }
    });
  }

  navigateToEdit(): void {
    if (this.providerId) {
      this.router.navigate(['/b2b/external-service-providers', this.providerId, 'edit']);
    }
  }

  navigateBack(): void {
    this.router.navigate(['/b2b/external-service-providers']);
  }

  formatCnpj(cnpj: string | undefined): string {
    if (!cnpj) return 'N/A';
    const digits = cnpj.replace(/\D/g, '');
    if (digits.length !== 14) return cnpj;
    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  formatPhone(phone: string | undefined): string {
    if (!phone) return 'N/A';
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
      return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else if (digits.length === 11) {
      return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }
    return phone;
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'N/A';
    try {
      const d = new Date(date);
      return d.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return date;
    }
  }

  getDocumentsWithUrl() {
    if (!this.provider || !this.provider.documents) {
      return [];
    }
    return this.provider.documents.filter(doc => doc.documentUrl);
  }

  getDocumentsCount(): number {
    return this.getDocumentsWithUrl().length;
  }

  hasDocumentsWithUrl(): boolean {
    return this.getDocumentsCount() > 0;
  }
}

